import React from 'react'
import PropTypes from 'prop-types'
import { getBrandingLogo } from 'portal-modules/auth/utils/get-branding-logo'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'

import styled from '@emotion/styled'

const { whilteLogo, bgImage } = getBrandingLogo
const { isTP } = getProjectConditions()

// Get custom background image for Tenant Portal
const getCustomBackgroundImage = () => {
  if (!isTP) return null
  
  try {
    const tpUtils = require('portal-modules/tenant-portal-layout/utils/get-login-background')
    return tpUtils.getLoginBackgroundUrl()
  } catch (error) {
    console.error('Error loading custom background image:', error)
    return null
  }
}

const customBgImage = getCustomBackgroundImage()

const StyledHeader = styled('header')`
  align-items: center;
  box-sizing: border-box;
  color: white;
  display: flex;
  justify-content: center;
  min-height: 30vh;
  padding: 24px 32px;
  position: relative;

  svg {
    width: 100%;
  }

  // Apply background image based on priority: custom > branding > none
  ${({ showBgImage }) => {
    const backgroundImage = customBgImage || (showBgImage ? bgImage : null)
    
    return backgroundImage ? `
      background-image: url(${backgroundImage});
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    ` : ''
  }};
`

const StyledWrapper = styled('div')`
  max-width: 300px;
  position: relative;
  width: 100%;
`

const StaticHeader = ({ icon: Icon, logo: Logo, iconSize }) => (
  <StyledHeader showBgImage={!!bgImage}>
    <StyledWrapper>
      <Logo />
      {!whilteLogo && <Icon size={iconSize} />}
    </StyledWrapper>
  </StyledHeader>
)

StaticHeader.defaultProps = {
  iconSize: 76,
}

StaticHeader.propTypes = {
  icon: PropTypes.any.isRequired,
  iconSize: PropTypes.number,
  logo: PropTypes.any.isRequired,
}

export default StaticHeader